<smart-table [headers]="headers"
             (filtersChange)="onSearch($event)"
             (sortChange)="onSort($event)"
             [source]="source">
  <ng-template smartTableColumn="id" let-item>
    <td>
      {{ item.name }} <br>
      <small class="text-muted">ID {{ item.id }}</small>
    </td>
  </ng-template>
  <ng-template smartTableColumn="createdAt" let-item>
    <td>
      {{ item.createdAt | moment }}
    </td>
  </ng-template>


  <ng-template smartTableColumn="product" let-item>
    <td>
      {{ item.purchase?.product?.name}}
    </td>
  </ng-template>

  <ng-template smartTableColumn="createdAt" let-item>
    <td>
      <ng-container *ngIf="item.createdAt">
        {{ item.createdAt | moment }}
      </ng-container>
    </td>
  </ng-template>

  <ng-template smartTableColumn="market" let-item>
    <td>
      <div class="d-flex align-items-center">
        <ng-container [ngSwitch]="item.market?.name">
          <icon-apple class="text-muted mb-1 mr-2" [style.width.px]="12" *ngSwitchCase="'apple'"></icon-apple>
          <icon-android class="text-muted mr-2" [style.width.px]="12" *ngSwitchCase="'google'"></icon-android>
        </ng-container>
        {{ item.market?.name }}
      </div>
    </td>
  </ng-template>


  <ng-template smartTableColumn="receipt" let-item>
    <td>
      <a class="border-dotted cursor-pointer" *ngIf="item.value" (click)="showReceipt(item)">
        {{ item.value?.substring(0, 20) }}...
      </a>
    </td>
  </ng-template>

</smart-table>

<pagination [itemsOnPage]="pagination.limit"
            [page]="pagination.currentPage"
            (pageChanged)="setPage($event)"
            [itemsFull]="pagination.fullCount"></pagination>

<preloader [hidden]="!loaderService.isLoading"></preloader>

